import classNames from "classnames";
import { forwardRef } from "react";

const prefix = "a-input";

const Input = forwardRef(({ autoComplete, className, name, errors, size, type, ...props }, ref) => {
  const componentClass = classNames(prefix, "bg-gray-100 rounded-lg p-3", {
    "w-[100%] h-10": !size && type !== "checkbox" && type !== "radio",
    "border-2 border-red-500": !!errors,
    "cursor-not-allowed": props?.readOnly,
    [size]: [size],
    [className]: className
  });

  return (
    <input 
      autoComplete={ autoComplete ?? "off"}
      name={name}
      ref={ref}
      className={componentClass}
      type={type}
      {...props}
    />
  );
});

export default Input;
